import { Toaster } from "react-hot-toast";
import { useTheme } from "@mui/material";

function ToasterConfig() {
  const theme = useTheme();

  const generalStyles = {
    fontSize: "12px",
    maxWidth: "500px",
    backgroundColor: theme.palette.background.primary,
    color: theme.palette.text.primary,
    border: `1px solid ${theme.palette.border.primary}`,
  };

  return (
    <Toaster
      position="top-center"
      gutter={24}
      containerStyle={{ margin: "8px" }}
      toastOptions={{
        success: {
          duration: 2500,
          style: generalStyles,
        },
        error: { duration: 2500, style: generalStyles },
      }}
    />
  );
}

export default ToasterConfig;
